import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import LoginPage from './auth/LoginPage';
import ProductList from './product/ProductList';
import ProductForm from './filler/ProductForm';
import ProtectedRoute from "./auth/ProtectedRoute";

const App: React.FC = () => {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage/>}/>

            <Route path="/" element={<ProtectedRoute children={<ProductList/>}/>}/>
            <Route path="/create-product" element={<ProtectedRoute children={<ProductForm/>}/>}/>
            <Route path="/edit-product/:documentId" element={<ProtectedRoute children={<ProductForm/>}/>}/>
            <Route path="*" element={<Navigate replace to="/404" />} />
        </Routes>
    );
};

export default App;
